<table mat-table [dataSource]='data'>
  <ng-content></ng-content>

  <tr class="mat-row" *matNoDataRow>
    <td class="mat-cell" [attr.colspan]="columns.length">{{ 'MESSAGESANDWARNINGS.noResultsFound' | translateOrFallback:'No results found' }}</td>
  </tr>

  <ng-container matColumnDef="loading">
    <td mat-footer-cell *matFooterCellDef [attr.colspan]="columns.length">{{ 'AGGRIDLOCALE.loadingOoo' | translateOrFallback:'Loading...' }}</td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="columns"></tr>
  <tr mat-row *matRowDef="let row; columns: columns;"></tr>
  <tr mat-footer-row *matFooterRowDef="['loading']" [hidden]="data !== null"></tr>
</table>
